import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faClock,
  faMoneyBillAlt,
  faBriefcase,
  faBookmark,
  faCalendarAlt,
  faCoins,
} from "@fortawesome/free-solid-svg-icons";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faLinkedin,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useParams } from "react-router-dom";
import {
  fetchJobAsync,
  selectJob,
} from "../employers/Employers Slice/employerJobs/employerJobSlice";
import { Dummy } from "../../pages/CommonPublicPages/Navbars/components/Dummy";

export function JobSingle() {
  const dispatch = useDispatch();
  const jobs = useSelector(selectJob);
  const { uuid } = useParams();

  useEffect(() => {
    dispatch(fetchJobAsync(uuid));
  }, [uuid, dispatch]);

  // console.log("jobs", jobs);

  return (
    <div className="mb-10">
      <Dummy />
      {jobs &&
        jobs.map((job) => (
          <div className="pb-96">
            <div className="flex flex-wrap justify-between px-16 py-16 bg-[#f3f7fc]">
              <div className="flex gap-3 px-10">
                <div>
                  <img
                    alt=""
                    className="h-20"
                    src="https://superio-reactjs.ibthemespro.com/images/resource/company-logo/1-1.png"
                  />
                </div>

                <div>
                  <h3>{job.job_title.title}</h3>
                  <div className="flex gap-3">
                    <p className="font-normal">
                      <FontAwesomeIcon icon={faBriefcase} />{" "}
                      {job.hiring_company_name}
                    </p>
                    <p className="font-normal">
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                      {job.job_locations.map((loc) => (
                        <span>
                          {" "}
                          {loc.job_location.title} {","}{" "}
                        </span>
                      ))}
                    </p>
                    <p className="font-normal">
                      <FontAwesomeIcon icon={faClock} /> 11 hours ago
                    </p>
                    <p className="font-normal">
                      <FontAwesomeIcon icon={faMoneyBillAlt} /> ₹
                      {job.salary_min_amount} - ₹{job.salary_max_amount}
                    </p>
                  </div>

                  <div className="flex gap-3">
                    <button className="rounded-full bg-[#daede3] text-green-500 px-2">
                      {job.job_tag}
                    </button>
                    <button className="rounded-full bg-[#d7e3f7] text-blue-700 px-2">
                      {job.job_type}
                    </button>
                  </div>
                </div>
              </div>
              <div className="px-10 mt-4 lg:mt-0">
                <Link
                  to={"/jobApply"}
                  className="rounded-lg px-3 py-3 bg-blue-700 text-white mr-6"
                >
                  Apply For Job
                </Link>
                <button className="bg-[#d7e2f7] py-3 px-4 rounded-lg">
                  <FontAwesomeIcon
                    className="text-gray-500 text-1xl"
                    icon={faBookmark}
                  />
                </button>
              </div>
            </div>

            <div className="flex flex-wrap mt-5 justify-between px-16">
              <div className="px-12 w-full lg:w-2/3 ">
                <div>
                  <h5>Job Description</h5>
                  <p className="text-gray-400">{job.job_description}</p>
                </div>
                <div className="mt-10">
                  <h5 className="mb-4">Key Responsibilities</h5>
                  <ul className="flex flex-col gap-4">
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and user acceptance
                      testing.
                    </li>
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and user acceptance
                      testing.
                    </li>
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and user acceptance
                      testing.
                    </li>
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and user acceptance
                      testing.
                    </li>
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and user acceptance
                      testing.
                    </li>
                  </ul>
                </div>

                <div className="mt-10">
                  <h5 className="mb-4">Skill & Experience</h5>
                  <ul className="flex flex-col gap-4">
                    <li>{job.job_skills[0].job_skill.title}</li>
                    <li>{job.job_skills[1].job_skill.title}</li>
                    <li>{job.job_skills[2].job_skill.title}</li>
                    <li>
                      Be involved in every step of the product design cycle from
                      discovery to developer handoff and
                    </li>
                  </ul>
                </div>

                <div className="flex gap-4 mt-10 mb-4">
                  <h5>Share this job</h5>
                  <div className="rounded-lg px-3 py-2 bg-[#3b5998] inline-block">
                    <div className="flex gap-3">
                      <FontAwesomeIcon
                        className="mt-1 text-white"
                        icon={faFacebook}
                      />
                      <p className="font-medium text-white mb-0">Facebook</p>
                    </div>
                  </div>
                  <div className="rounded-lg px-3 py-2 bg-[#007bb5] inline-block">
                    <div className="flex gap-3">
                      <FontAwesomeIcon
                        className="mt-1 text-white"
                        icon={faLinkedin}
                      />
                      <p className="font-medium text-white mb-0">Linkedin</p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-3">
                  <div>
                    <h4 className="my-3">Related Jobs</h4>
                    <p className="text-gray-600">
                      2020 jobs live - 293 added today.
                    </p>
                  </div>

                  <div className="flex flex-wrap justify-between bg-[#f3f7fc] p-4 border rounded-lg mb-4">
                    <div className="flex gap-3">
                      <div>
                        <img
                          alt=""
                          className="h-15"
                          src="https://superio-reactjs.ibthemespro.com/images/resource/company-logo/1-1.png"
                        />
                      </div>

                      <div>
                        <h5>Software Engineer (Android), Libraries</h5>
                        <div className="flex gap-3">
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faBriefcase} /> Segment
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> London, UK
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faClock} /> 11 hours ago
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faMoneyBillAlt} /> ₹35k-₹45k
                          </p>
                        </div>

                        <div className="flex gap-3">
                          <button className="rounded-full bg-[#d7e3f7] text-blue-700 px-2">
                            Full Time
                          </button>
                          <button className="rounded-full bg-[#daede3] text-green-500 px-2">
                            Private
                          </button>
                          <button className="rounded-full bg-[#f7edd7] text-yellow-400 px-2">
                            Urgent
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="px-10">
                      <FontAwesomeIcon
                        className="text-gray-500 text-1xl"
                        icon={faBookmark}
                      />
                    </div>
                  </div>

                  <div className="flex flex-wrap justify-between bg-[#f3f7fc] p-4 border rounded-lg">
                    <div className="flex gap-3">
                      <div>
                        <img
                          alt=""
                          className="h-15"
                          src="https://superio-reactjs.ibthemespro.com/images/resource/company-logo/1-1.png"
                        />
                      </div>

                      <div>
                        <h5>Software Engineer (Android), Libraries</h5>
                        <div className="flex gap-3">
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faBriefcase} /> Segment
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faMapMarkerAlt} /> London, UK
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faClock} /> 11 hours ago
                          </p>
                          <p className="font-normal">
                            <FontAwesomeIcon icon={faMoneyBillAlt} /> ₹35k-₹45k
                          </p>
                        </div>

                        <div className="flex gap-3">
                          <button className="rounded-full bg-[#d7e3f7] text-blue-700 px-2">
                            Full Time
                          </button>
                          <button className="rounded-full bg-[#daede3] text-green-500 px-2">
                            Private
                          </button>
                          <button className="rounded-full bg-[#f7edd7] text-yellow-400 px-2">
                            Urgent
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="px-10">
                      <FontAwesomeIcon
                        className="text-gray-500 text-1xl"
                        icon={faBookmark}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white h-screen px-12 w-full lg:w-1/3 mt-10 lg:mt-0">
                <div className="bg-[#f3f7fc] px-4 pt-6 rounded-lg">
                  <div>
                    <h5 className="mb-4">Job Overview</h5>
                    <div>
                      <div className="flex gap-3 mb-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faCalendarAlt}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">
                            Date Posted:{" "}
                          </p>
                          <label className="text-gray-500 font-norma">
                            Posted 1 hours ago
                          </label>
                        </div>
                      </div>

                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faClock}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">
                            Expiration date:{" "}
                          </p>
                          <label className="text-gray-500 font-norma">
                            April 06, 2021
                          </label>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faMapMarkerAlt}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">
                            Location:
                          </p>
                          <label className="text-gray-500 font-norma">
                            London, UK{" "}
                          </label>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faUserAlt}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">
                            Job Title:
                          </p>
                          <label className="text-gray-500 font-norma">
                            Designer
                          </label>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faClock}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">Hours:</p>
                          <label className="text-gray-500 font-norma">
                            50h / week{" "}
                          </label>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faCoins}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">Rate:</p>
                          <label className="text-gray-500 font-norma">
                            ₹15 - ₹25 / hour
                          </label>
                        </div>
                      </div>
                      <div className="flex gap-3 mt-3">
                        <FontAwesomeIcon
                          className="text-blue-500 mt-1"
                          icon={faMoneyBillAlt}
                        />
                        <div className="my-0">
                          <p className="text-black font-normal my-0">Salary:</p>
                          <label className="text-gray-500 font-norma">
                            ₹35k - ₹45k
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-10">
                    <h5 className="mb-4">Job Skills</h5>
                    <div className="flex gap-2 flex-wrap">
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        app{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        JavaScript{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        C++{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        Java{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        Node.js{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        Mongoose{" "}
                      </p>
                      <p className="bg-white px-2 py-1 rounded-lg inline-block">
                        {" "}
                        web dev{" "}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-[#f3f7fc] mt-4 px-4 pt-6 rounded-lg">
                  <div className="flex gap-4">
                    <div>
                      <img
                        alt=""
                        className="h-14"
                        src="https://superio-reactjs.ibthemespro.com/images/resource/company-logo/1-1.png"
                      />
                    </div>
                    <div>
                      <h5>Segment</h5>
                      <p className="text-blue-700 font-normal">
                        View company profile
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 pb-10">
                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">
                        Primary industry:
                      </p>
                      <p className="font-medium text-[#6d6c6c]">Software</p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">
                        Company size:
                      </p>
                      <p className="font-medium text-[#6d6c6c]">501-1,000</p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">
                        Founded in:
                      </p>
                      <p className="font-medium text-[#6d6c6c]">2011</p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">Phone:</p>
                      <p className="font-medium text-[#6d6c6c]">123 456 7890</p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">Email:</p>
                      <p className="font-medium text-[#6d6c6c]">
                        info@joio.com
                      </p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">Location:</p>
                      <p className="font-medium text-[#6d6c6c]">London, UK</p>
                    </div>

                    <div className="flex justify-between">
                      <p className="font-semibold text-[#292828]">Social:</p>
                      <div className="flex gap-3">
                        <FontAwesomeIcon
                          className="text-gray-600"
                          icon={faFacebook}
                        />
                        <FontAwesomeIcon
                          className="text-gray-600"
                          icon={faTwitter}
                        />
                        <FontAwesomeIcon
                          className="text-gray-600"
                          icon={faInstagram}
                        />
                        <FontAwesomeIcon
                          className="text-gray-600"
                          icon={faLinkedin}
                        />
                      </div>
                    </div>

                    <button className="bg-[#d7e2f7] rounded-lg text-blue-700 w-full text-center py-3">
                      Company website
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}
